<template>
  <article class="card">
    <div class="card-content text-center">
      <h1
        class="text-6xl mb-0"
        v-text="activeMembershipsCount"
      />
      <p
        class="uppercase text-grey mt-0"
        v-text="'Members'"
      />
      <a
        v-can="'create-profiles'"
        :href="membersLink"
        class="btn btn--border"
        v-text="'View Members'"
      />
    </div>
    <hr>
    <div class="card-content text-center">
      <h1
        class="text-6xl mb-0"
        v-text="communicationsCount"
      />
      <p
        class="uppercase text-grey mt-0"
        v-text="'Communications'"
      />
      <a
        v-can="['create-discussions', 'create-blog-entries', 'create-email', 'create-sms']"
        :href="communicationsLink"
        class="btn btn--border"
        v-text="'View Communications'"
      />
    </div>
    <hr>
    <div class="card-content text-center">
      <h1
        class="text-6xl mb-0"
        v-text="documentsCount"
      />
      <p
        class="uppercase text-grey mt-0"
        v-text="'Documents'"
      />
      <a
        v-can="'create-documents'"
        :href="documentsLink"
        class="btn btn--border"
        v-text="'View Documents'"
      />
    </div>
  </article>
</template>

<script type="text/babel">
export default {
  name: 'DashboardStats',
  props: {
    activeMembershipsCount: {
      type: Number,
      required: true,
    },
    communicationsCount: {
      type: Number,
      required: true,
    },
    documentsCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    membersLink() {
      return `${this.$urlGenerator.active()}members`
    },
    communicationsLink() {
      return `${this.$urlGenerator.active()}communications`
    },
    documentsLink() {
      return `${this.$urlGenerator.active()}documents`
    },
  },
}
</script>
